import React from 'react';

import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';

export const AtlassianIntelligenceLogo = ({ alt }: { alt: string }) => (
	<AtlassianIntelligenceIcon color="currentColor" label={alt} />
);
